module.exports = require("!!vue-loader!./../../node_modules/vue-markdown-loader/_cache/button-1.vue");


//////////////////
// WEBPACK FOOTER
// ./docs/examples/button.md
// module id = 225
// module chunks = 0